export const CLEAR = '@@rehydrate/CLEAR';
export const UPDATE = '@@rehydrate/UPDATE';
export const REHYDRATED = '@@rehydrate/REHYDRATED';
export const SET_PERSIST_REHYDRATE = '@@rehydrate/SET_PERSIST_REHYDRATE';

export const RESIST_REHYDRATE = 'persist/REHYDRATE';
